import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickOutsideDirective } from './click-outside/click-outside.directive';
import { FormSubmittableDirective } from './form-submittable/form-submittable.directive';
import { KeyboardTranslateDirective } from './keyboard-translate/keyboard-translate.directive';
import { FeatureFlagDirective } from './feature-flag/feature-flag.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [ClickOutsideDirective, FormSubmittableDirective, KeyboardTranslateDirective, FeatureFlagDirective],
  exports: [ClickOutsideDirective, FormSubmittableDirective, KeyboardTranslateDirective, FeatureFlagDirective],
})
export class DirectiveModule {}
